import { React, useEffect, useState } from "react";
import { IntroductionHeader } from "../../dashboard/Dashboard";
import InformationHeader from "../Partials/InformationHeader";
import { AddproductWrapper } from "../../Products/ProductsPage.styled";
import FormAccordion from "../../../components/Form/FormAccordion";
import { InputField, FileGroup } from "../../../components/Form/FormComponents";
import { Button } from "../../Products/Forms/ProductForm.styled";
import { fetchAFobject } from "../../apprenticeship/utils";
import { useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import { getFormattedDate } from "../../../utils/DateUtils";
import { FormGroup } from "../../customer/customersPage.styled";
import Parse from "../../../api/ApiConfig";
import { AiOutlineInfoCircle } from "react-icons/ai";

function AFRequestInformation() {
	let { id } = useParams();
	const [loading, setLoading] = useOutletContext();
	const [formData, setFormData] = useState(null);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
		// console.log(formData);
	};
	useEffect(() => {
		setLoading(true);
		getAFData();
	}, []);

	const getAFData = async () => {
		const data = await fetchAFobject(id);
		if (data && !data?.error) {
			setLoading(false);
			setFormData(data.result);
			// console.log(data.result);
		} else {
			setLoading(false);
			setFormData(data);
			toast.error(data?.error || "Error fetching data!");
		}
	};

	const updateAF = () => {
		try {
			const AF = Parse.Object.extend("ApprenticeshipFinance");
			const AFObject = new AF();
			AFObject.id = id;
			AFObject.save({
				hmemail: formData.hmemail,
				hmlocation: formData.hmlocation,
				hmphone: formData.hmphone,
			}).then(() => {
				// console.log("parseObject updated:", result);
				setLoading(false);
				toast.success("Head of market details updated successfully!");
			});
		} catch (error) {
			// console.log(error);
			setLoading(false);
			toast.error("Error updating head of market details");
		}
	};

	return (
		<>
			<IntroductionHeader nav={true} />
			<InformationHeader data={formData} />
			<AddproductWrapper>
				<FormAccordion title='Apprentice Request Information' open={true}>
					<div className='grid grid-cols-5 gap-6'>
						{/* first row */}
						<FormGroup>
							<label>DATE / TIME</label>
							<InputField
								name='createdAt'
								value={getFormattedDate(formData?.createdAt)}
							/>
						</FormGroup>

						<FormGroup>
							<label>TRN ID</label>
							<InputField
								name='trnId'
								value={"TRN-" + formData?.objectId || "--"}
							/>
						</FormGroup>

						<FormGroup>
							<label>BUSINESS TYPE</label>
							<InputField name='businessType' value={formData?.businessType} />
						</FormGroup>

						<FormGroup>
							<label>APPRENTICE</label>
							<InputField
								name='apprentice'
								value={(formData?.name1 || "--") + " " + (formData?.name2 || "--")}
							/>
						</FormGroup>

						<FormGroup>
							<label>AMOUNT RAISED</label>
							<InputField
								name='amountToRaise'
								value={formData?.amountToRaise}
							/>
						</FormGroup>
						{/* end of first row */}

						{/* second row */}
						<FormGroup>
							<label>COMMITMENT FEE</label>
							<InputField
								name='commitmentFee'
								value={formData?.commitmentFee}
							/>
						</FormGroup>

						<FormGroup>
							<label>EXPECTED PROFIT</label>
							<InputField
								name='expectedProfit'
								value={formData?.expectedProfit}
							/>
						</FormGroup>

						<FormGroup>
							<label>PROGRAM SAVINGS</label>
							<InputField
								name='paymentSavings'
								value={formData?.programSavings}
							/>
						</FormGroup>

						<FormGroup>
							<label>INTEREST RATE</label>
							<InputField name='interestRate' value={formData?.interestRate} />
						</FormGroup>

						<FormGroup>
							<label>AF DURATION</label>
							<InputField name='duration' value={formData?.duration} />
						</FormGroup>

						{/* third row */}
						<FormGroup>
							<label>BUSINESS DESCRIPTION</label>
							<InputField value={formData?.businessDescription} />
						</FormGroup>

						<FormGroup>
							<label>PURPOSE</label>
							<InputField name='purpose' value={formData?.purpose} />
						</FormGroup>

						{/* <FormGroup>
							<label>BUSINESS PHOTO</label>
							<FileGroup value={formData?.businessPhoto} />
						</FormGroup> */}
					</div>
				</FormAccordion>

				<FormAccordion title='Documents' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<FormGroup>
							<label>BUSINESS DOCUMENT</label>
							<FileGroup value={formData?.attachmentFile?.url} />
						</FormGroup>

						<FormGroup>
							<label>PROOF OF PURCHASE</label>
							<FileGroup value={formData?.proofOfPurchaseDoc?.url} />
						</FormGroup>

						<FormGroup>
							<label>PRODUCT IMAGE </label>
							<FileGroup value={formData?.imageProof?.url} />
						</FormGroup>
					</div>
				</FormAccordion>

				{/* Apprentice Details */}
				<FormAccordion title='Apprentice Details' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<FormGroup>
							<label>APPRENTICE</label>
							<InputField
								name='apprentice'
								value={(formData?.name1 || "--") + " " + (formData?.name2 || "--")}
							/>
						</FormGroup>

						<FormGroup>
							<label>PHONE NUMBER</label>
							<InputField name='phone' value={formData?.user?.phone} />
						</FormGroup>

						<FormGroup>
							<label>HOME ADDRESS</label>
							<InputField name='address' value={formData?.user?.homeAddress} />
						</FormGroup>
					</div>
				</FormAccordion>

				<FormAccordion title='Apprentice Head of Market Details' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<FormGroup>
							<label>PHONE NUMBER</label>
							<InputField
								name='hmphone'
								handleChange={handleInputChange}
								value={formData?.hmphone}
								isEditable={true}
							/>
						</FormGroup>

						<FormGroup>
							<label>EMAIL ADDRESS</label>
							<InputField
								name='hmemail'
								handleChange={handleInputChange}
								value={formData?.hmemail}
								isEditable={true}
								type={"email"}
							/>
						</FormGroup>

						<FormGroup>
							<div className='flex gap-2'>
								<label>LOCATION</label>
								<AiOutlineInfoCircle size={24} color='red' />
							</div>

							<InputField
								name='hmlocation'
								handleChange={handleInputChange}
								value={formData?.hmlocation}
								isEditable={true}
							/>
						</FormGroup>
					</div>
				</FormAccordion>

				<div className='end mx-5'>
					<Button
						onClick={updateAF}
						type='submit'
						color='#ffffff'
						backgroundcolor='#003A50'
						customwidth={"5rem"}
					>
						<p>Save</p>
					</Button>
				</div>
				{loading && (
					<Backdrop
						sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={loading}
					>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
			</AddproductWrapper>
		</>
	);
}

export default AFRequestInformation;
